import { render, staticRenderFns } from "./previewBlock.vue?vue&type=template&id=7515e24d&scoped=true&"
import script from "./previewBlock.vue?vue&type=script&lang=js&"
export * from "./previewBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7515e24d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VHover,VSheet})
